import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ButtonSet, Button, MatchEvent } from '../../../models';
import { TimerService, ButtonService } from '../../../services';
import * as functions from '../../../common';

@Component({
  selector: 'coding-buttons',
  template: `
    <nav *ngIf="buttonSet" class="sidenav-buttons">
        <ul>
            <li *ngFor="let button of buttonSet.buttons">
                <a (click)="onButtonClick(button)"> {{ button.name }} </a>
            </li>
        </ul>
    </nav>
  `,
  styleUrls: ['./coding-buttons.component.css']
})
export class CodingButtonsComponent implements OnInit {
  @Input() buttonSetId: string;

  @Output() codeClick = new EventEmitter<MatchEvent>();
  buttonSet: ButtonSet;

  constructor(private timerService: TimerService, private buttonService: ButtonService) {}

  ngOnInit(): void {
    if (this.buttonSetId) {
      this.buttonService.get(this.buttonSetId).subscribe(buttonSet => {
        console.info('[CodingButtonsComponent] Retreived buttonset:', buttonSet);
        this.buttonSet = buttonSet;
      });
    }
  }

  onButtonClick(button: Button) {
    const seconds = this.timerService.getTime();
    const identifier = functions.getTimestamp();
    console.info('[CodingButtonsComponent] onButtonClick: ', seconds, identifier, button);

    const codingEvent = {
      ...button,
      seconds,
      eventType: button.eventType,
      color: button.color.toLowerCase(),
      identifier
    } as MatchEvent;

    this.codeClick.emit(codingEvent);
  }
}
